import React, { Component } from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';
import {FaCopyright} from "react-icons/all";
import { connect } from 'react-redux';

class Footer extends Component {
  render() {
    return (
        <>
            <Navbar>
                <Nav navbar>
                    <NavItem>
                        2022 <FaCopyright /> <a href={ this.props.config.website_domain } target="_blank" rel="noreferrer">{ this.props.config.website_title }</a>
                    </NavItem>
                </Nav>
            </Navbar>
        </>
    ); 
  }
}

const mapStateToProps = (state) => {
    return {
        config: state.configSystem.config,
    }
}
export default connect(mapStateToProps)(Footer);
